import LegalPageLayout from "@/components/legal/LegalPageLayout";
import { ShieldCheck } from "lucide-react";

const REGISTRATIONS = [
  { label: "PAN", value: "AADTA0943K" },
  { label: "80G Registration No.", value: "AADTA0943K25MB02", note: "u/s 80G(5), valid AY 2027-28 to 2031-32" },
  { label: "12AB Registration No.", value: "AADTA0943K25MB01", note: "valid AY 2027-28 to 2031-32" },
  { label: "CSR-1 Registration No.", value: "CSR00003005" },
  { label: "FCRA Registration No.", value: "083781442", note: "valid to 31-07-2029" },
];

export default function Transparency() {
  return (
    <LegalPageLayout title="Transparency" testId="transparency-page">
      <p className="flex items-start gap-2 bg-white border border-amtm-teal/30 rounded-2xl p-5 text-amtm-text" data-testid="transparency-80g-note">
        <ShieldCheck className="h-5 w-5 text-amtm-teal shrink-0 mt-0.5" />
        <span>
          <strong>All donations to Animal Matter To Me are eligible for tax exemption under Section 80G</strong> of
          the Income Tax Act, 1961. A receipt with our 80G registration number is issued automatically for every
          donation.
        </span>
      </p>

      <h2>Our registrations</h2>
      <div className="not-prose grid sm:grid-cols-2 gap-3 mt-2">
        {REGISTRATIONS.map((r) => (
          <div key={r.label} className="bg-white rounded-xl border border-amtm-border p-4" data-testid={`transparency-reg-${r.label.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
            <p className="text-xs uppercase tracking-wide text-amtm-textMuted mb-1">{r.label}</p>
            <p className="font-semibold text-amtm-text">{r.value}</p>
            {r.note && <p className="text-xs text-amtm-textMuted mt-0.5">{r.note}</p>}
          </div>
        ))}
      </div>

      <h2>Registered address</h2>
      <p>
        Animal Matter To Me, Mumbai
        <br />
        CTS 166/167 Ashram, Madh Marve Road, Madh Jetti, Behind Manthara Residency,
        <br />
        Malad West, Village Erangal, Mumbai &ndash; 400061, Maharashtra, India
      </p>

      <h2>How we use your donations</h2>
      <p>
        Case-specific donations go directly towards that animal's treatment and care. General and Guardian
        donations fund our ongoing rescue, veterinary, sheltering, and feeding programmes.
      </p>
      <p data-testid="transparency-surplus-fund-note">
        If a rescue is funded beyond its goal, or if an animal's needs change, surplus funds go directly to the
        feeding programme for animals at our sanctuary.
      </p>

      <h2>Foreign contributions</h2>
      <p>
        Under the Foreign Contribution (Regulation) Act, 2010, AMTM's foreign contributions may only be received
        into our designated FCRA bank account. This is why donations on this Site are accepted from Indian
        residents/citizens only - see our <a href="/contact">Contact Us</a> page for international giving.
      </p>
    </LegalPageLayout>
  );
}
